<template>
  <VDatepicker
    v-model="dateModel"
    :format="$t('common.dateFormatDatePicker')"
    :lang="$i18n.locale"
    :input-class="'form-input ' + inputClass"
    :clearable="clearable"
    class="datepicker"
    v-bind="$attrs"
    @input-error="onInputError"
  >
    <template #icon-calendar>
      <i class="mx-icon-calendar">
        <FontAwesomeIcon :icon="faCalendar" />
      </i>
      <span v-if="errCnt" :key="errCnt" class="sr-only" role="alert">
        {{ $t('common.errInvalidDate') }}
      </span>
    </template>
    <template #header="{ emit }">
      <button type="button" class="close" @click="emit(dateModel)">
        <VSvgIcon name="cancel" variant="outlined" size="middle" />
        <span class="sr-only">{{ $t('common.close') }}</span>
      </button>
    </template>
  </VDatepicker>
</template>

<script>
import { faCalendar } from '@fortawesome/free-solid-svg-icons/faCalendar';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import 'vue2-datepicker/locale/de';
import VDatepicker from './component';
import VSvgIcon from '@/components/UI/VSvgIcon.vue';

export default {
  name: 'DatePicker',

  components: {
    VSvgIcon,
    VDatepicker,
    FontAwesomeIcon,
  },

  inheritAttrs: false,

  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },

  props: {
    modelValue: {
      type: [Date, String],
      required: false,
      default: '',
    },

    clearable: {
      type: Boolean,
      required: false,
    },

    inputClass: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      faCalendar,
      errCnt: 0,
    };
  },

  computed: {
    dateModel: {
      get() {
        return this.modelValue;
      },
      set(v) {
        if (!this.clearable && v === null && this.modelValue !== null) {
          this.errCnt++;
          this.$emit('update:modelValue', this.modelValue);
        } else {
          this.$emit('update:modelValue', v);
        }
      },
    },
  },

  methods: {
    onInputError(e) {
      this.errCnt++;
    },
  },
};
</script>

<!-- not scoped! -->
<style lang="scss">
@import '~@scss';
$sidebar-margin-left: 150px;
$primary-color: $color-function;
$default-color: $font-color-regular;
@import '~vue2-datepicker/scss/index.scss';

.#{$namespace}-datepicker-header {
  position: relative;
  z-index: $popup-z-index + 1;
  padding: 12px;
  border-bottom: none;
}

@media screen and (-ms-high-contrast: active) {
  .#{$namespace}-calendar-content {
    .cell {
      &:hover,
      &.active {
        font-weight: bold;
        text-decoration: underline;
      }

      &.disabled {
        font-style: italic;
      }
    }
  }
}
</style>
